import React, { Component } from 'react';
import moment from 'moment-timezone';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

class BalanceContainer extends Component {

    didChangeTime = (start_date) => {
        const startDate = moment(start_date, 'YYYY-MM-DD HH:mm:ss');
        return startDate
    }
    render() {
        const balance = this.props.balance
        const { t } = this.props;
        const ruta_imagen = 'https://img.iosoffices.com/img/salas_imagenes/salas/'
        const sum = this.props.new_balance.TotalHrsGrandesDisponibles + this.props.new_balance.TotalHrsChicasDisponibles
        const sum_usa =  this.props.new_balance.hrsGrandesUtilizadas + this.props.new_balance.hrsChicasUtilizadas
        return (
            <div className="containere_balance">
                <div className="col-md-12">
                    <div className="col-md-12">
                        <div className="alert alert-info">
                            {t('dashboard.reservations.big_remaining_hours') + " "}{this.props.new_balance.TotalHrsGrandesDisponibles > 0 ? this.props.new_balance.TotalHrsGrandesDisponibles : 0}
                            <br />
                            {t('dashboard.reservations.small_remaining_hours') + " "}{this.props.new_balance.TotalHrsChicasDisponibles > 0 ? this.props.new_balance.TotalHrsChicasDisponibles : 0}
                            <br />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="alert alert-info">
                            {t('dashboard.reservations.label_big_hours') + " "}{this.props.new_balance.hrsGrandesUtilizadas > 0 ? this.props.new_balance.hrsGrandesUtilizadas : 0}
                            <br />
                            {t('dashboard.reservations.label_small_hours') + " "}{this.props.new_balance.hrsChicasUtilizadas > 0 ? this.props.new_balance.hrsChicasUtilizadas : 0}
                            <br />
                        </div>
                    </div>
                </div>
                <div className="balance_hours">
                    <h4 className="iossala">Ultimas Reservaciones</h4>
                </div>
                <div id="carousel-example-generic" className="carousel slide" data-ride="carousel">
                    <div className="carousel-inner" role="listbox">
                        {balance.events.map((event, index) => (
                            index === 0 ? (
                                <div key={index} className="item active">
                                    <div className="card-panel panel panel-default card">
                                        <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + ruta_imagen + event.nombre_imagen + "')" }}>
                                        </div>
                                        <div className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{event.centro_name}</h4>
                                                <h4 className="iossala">{event.name}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                <div className="contenedor-flexbox">
                                                    <div className="contenedor">
                                                        <i className="fa fa-calendar" aria-hidden="true"></i>
                                                        {this.didChangeTime(event.start).format('LL')}
                                                    </div>
                                                    <div className="contenedor">
                                                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                        {this.didChangeTime(event.start).format('HH:mm')} - {this.didChangeTime(event.finish).format('HH:mm')}
                                                    </div>
                                                    <div className="contenedor">
                                                        <i className="fa fa-users" aria-hidden="true">
                                                        </i>
                                                        {event.people}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel-body-bottom">
                                                <div className="panel-body form-group">
                                                    {/* <Link to={'/reservation/' + event.id}>
                                                        <button
                                                            className="btn btn-primary btn-singup"
                                                            type="button">
                                                            {t('dashboard.profile.reservation')}
                                                        </button>
                                                    </Link> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div key={index} className="item">
                                    <div className="card-panel panel panel-default card">
                                        {event.nombre_imagen ? (
                                            <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + ruta_imagen + event.nombre_imagen + "')" }}>
                                            </div>
                                        ) : (
                                            <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + ruta_imagen + "muestra.jpg" + "')" }}>
                                            </div>
                                        )}
                                        <div className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{event.centro_name}</h4>
                                                <h4 className="iossala">{event.name}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                <div className="contenedor-flexbox">
                                                    <div className="contenedor">
                                                        <i className="fa fa-calendar" aria-hidden="true"></i>
                                                        {this.didChangeTime(event.start).format('LL')}
                                                    </div>
                                                    <div className="contenedor">
                                                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                        {this.didChangeTime(event.start).format('HH:mm')} - {this.didChangeTime(event.finish).format('HH:mm')}
                                                    </div>
                                                    <div className="contenedor">
                                                        <i className="fa fa-users" aria-hidden="true">
                                                        </i>
                                                        {event.people}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel-body-bottom">
                                                <div className="panel-body form-group">
                                                    {/* <Link to={'/reservation/' + event.id}>
                                                        <button
                                                            className="btn btn-primary btn-singup"
                                                            type="button">
                                                            {t('dashboard.profile.reservation')}
                                                        </button>
                                                    </Link> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        ))}
                    </div>
                    <a className="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
                        <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a className="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
                        <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a>
                </div>
            </div>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(BalanceContainer);


// WEBPACK FOOTER //
// ./src/dashboard/mainPage/BalanceContainer.js